import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';
import { usePermissions } from '@shared/hooks/usePermissions';

export const BankAccountsBreadcrumb = () => {
  const { t: tBankAccounts } = useTranslation('bankAccountsModule');
  const { t: tWallets } = useTranslation('walletsModule');
  const { getTeamType } = usePermissions();
  const teamType = getTeamType();
  const isExternal = teamType === 'tenant_external';

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    const items: BreadcrumbItem[] = [];

    if (isExternal) {
      items.push({
        label: tWallets('breadcrumbs.wallet'),
        path: '/wallets',
      });
    }

    items.push({
      label: tBankAccounts('breadcrumbs.bankAccounts'),
    });

    return items;
  }, [tBankAccounts, tWallets, isExternal]);

  usePageNavigation({ breadcrumbs });

  return null;
};
